<template>
    <v-container grid-list-md fluid>
        <template v-if="isAuthorized">
            <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                <v-col cols="2">
                    <v-btn-primary
                        block
                        v-if="currentUser.profile.configuration.accounting.write"
                        :disabled="!companyId || !accountingPeriod"
                        :loading="exportFECLoading"
                        @click="exportDialog = true"
                        data-cy="ExportAccounting-export"
                        >Export</v-btn-primary
                    >
                    <oss-dialog
                        v-model="exportDialog"
                        title="Export"
                        minWidth="40vw"
                        maxWidth="50vw"
                        :previous-display="step !== 'default' && isAllowedTo"
                        :previous-disabled="step === 'default' || !isAllowedTo"
                        @previous="previousStep()"
                        @close="defaultStep"
                        width="60vw"
                    >
                        <v-window v-model="step">
                            <v-window-item value="default">
                                <v-list subheader lines="two">
                                    <!-- ** export_fec -->
                                    <v-tooltip v-if="isTrainingOffer">
                                        <template #activator="{ props }">
                                            <v-list-item
                                                :class="
                                                    !$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item'
                                                        : 'mb-2 px-2 oss-list-item'
                                                "
                                                v-bind="props"
                                            >
                                                <v-list-item-title>Export FEC</v-list-item-title>
                                                <v-list-item-subtitle style="white-space: normal"
                                                    >Export du fichier FEC (avec ou sans les
                                                    documents associés) sur la periode comptable
                                                    selectionnée ou uniquement les écritures
                                                    comptables non-exportées</v-list-item-subtitle
                                                >

                                                <template v-slot:append>
                                                    <v-btn-next />
                                                </template>
                                            </v-list-item>
                                        </template>
                                        <span>{{ $t("training-text.normal-text") }}</span>
                                    </v-tooltip>
                                    <v-list-item
                                        v-else
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        @click="
                                            fecDates();
                                            step = 'export_fec_general';
                                        "
                                    >
                                        <v-list-item-title>Export FEC</v-list-item-title>
                                        <v-list-item-subtitle style="white-space: normal"
                                            >Export du fichier FEC (avec ou sans les documents
                                            associés) sur la periode comptable selectionnée ou
                                            uniquement les écritures comptables
                                            non-exportées</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>

                                    <!-- ** export_log -->

                                    <v-tooltip v-if="isTrainingOffer">
                                        <template #activator="{ props }">
                                            <v-list-item
                                                :class="
                                                    !$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item rounded-lg'
                                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                                "
                                                v-bind="props"
                                            >
                                                <v-list-item-title
                                                    >Export journal général</v-list-item-title
                                                >
                                                <v-list-item-subtitle
                                                    >Export du journal général global ou
                                                    partiel</v-list-item-subtitle
                                                >

                                                <template v-slot:append>
                                                    <v-btn-next />
                                                </template>
                                            </v-list-item>
                                        </template>
                                        <span>
                                            {{ $t("training-text.normal-text") }}
                                        </span>
                                    </v-tooltip>
                                    <v-list-item
                                        v-else
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        "
                                        :disabled="!companyId || !accountingPeriod"
                                        @click="
                                            fecDates();
                                            step = 'export_log';
                                        "
                                    >
                                        <v-list-item-title
                                            >Export journal général</v-list-item-title
                                        >
                                        <v-list-item-subtitle
                                            >Export du journal général global ou
                                            partiel</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>

                                    <!-- ** exportGeneralLedger -->
                                    <v-tooltip v-if="isTrainingOffer">
                                        <template #activator="{ props }">
                                            <v-list-item
                                                :class="
                                                    !$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item rounded-lg'
                                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                                "
                                                v-bind="props"
                                            >
                                                <v-list-item-title
                                                    >Export du grand livre et/ou de la
                                                    balance</v-list-item-title
                                                >
                                                <v-list-item-subtitle>
                                                    <!-- Export du grand livre et de la balance au format Excel -->
                                                </v-list-item-subtitle>

                                                <template v-slot:append>
                                                    <v-btn-next />
                                                </template>
                                            </v-list-item>
                                        </template>
                                        <span>{{ $t("training-text.normal-text") }}</span>
                                    </v-tooltip>
                                    <v-list-item
                                        v-else
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        "
                                        :disabled="!companyId || !accountingPeriod"
                                        @click="
                                            exportGeneralLedgerDialog = true;
                                            fecDates();
                                        "
                                    >
                                        <v-list-item-title
                                            >Export du grand livre et/ou de la
                                            balance</v-list-item-title
                                        >
                                        <v-list-item-subtitle>
                                            <!-- Export du grand livre et de la balance au format Excel -->
                                        </v-list-item-subtitle>

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>

                                    <!-- ** Etats financiers -->
                                    <v-list-item
                                        v-if="isAllowedTo && isUserHasAccess"
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        @click="
                                            accountingBookletDialog = true;
                                            exportDialog = false;
                                            fecDates();
                                        "
                                    >
                                        <v-list-item-title data-cy="ExportAccounting-plaquette"
                                            >Etats financiers</v-list-item-title
                                        >
                                        <v-list-item-subtitle
                                            >Export état financier
                                            personnalisé</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>

                                    <!-- ** Export office -->
                                    <v-list-item
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        @click="
                                            step = 'export_office_1';
                                            fecDates();
                                        "
                                    >
                                        <v-list-item-title />Export office
                                        <v-list-item-subtitle
                                            >Export de données dans un document
                                            office</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>
                                    <template v-if="extensions.length">
                                        <v-divider class="my-3" />
                                        <v-list-item
                                            :class="
                                                !$vuetify.display.mobile
                                                    ? 'mb-2 oss-list-item'
                                                    : 'mb-2 px-2 oss-list-item'
                                            "
                                            @click="
                                                step = 'export_extensions';
                                                fecDates();
                                            "
                                        >
                                            <v-list-item-title data-cy="ExportAccounting-extensions"
                                                >Extensions</v-list-item-title
                                            >
                                            <v-list-item-subtitle
                                                >Vos extensions</v-list-item-subtitle
                                            >

                                            <template v-slot:append>
                                                <v-btn-next />
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list>
                            </v-window-item>
                            <v-window-item value="export_fec_general">
                                <v-form v-model="isExportFECValid">
                                    <v-row
                                        v-if="
                                            selectedCompany &&
                                            !selectedCompany.siret &&
                                            !selectedCompany.siren
                                        "
                                    >
                                        <v-col>
                                            <h3 style="color: red">
                                                Afin de pouvoir générer un fichier avec le formatage
                                                FEC "SIREN + FEC + YYYYMMDD", veuillez renseigner
                                                vos numéros de SIREN et SIRET dans Mon Dossier. A
                                                défault, il sera remplacé par "pasDeSiren".
                                            </h3>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="noExportFecData">
                                        <v-col>
                                            <h3 style="color: red">Aucune donnée à exporter.</h3>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters class="d-flex py-2 align-center">
                                        <v-col cols="3">
                                            <v-tooltip
                                                v-if="disabledPermanentFecBtn && tooltipMessage"
                                                location="top"
                                            >
                                                <template v-slot:activator="{ props }">
                                                    <div v-bind="props">
                                                        <v-checkbox
                                                            label="Export normé définitif"
                                                            v-model="fecExportOptions.permanentFEC"
                                                            :disabled="disabledPermanentFecBtn"
                                                            color="primary"
                                                        />
                                                    </div>
                                                </template>
                                                <span>{{ tooltipMessage }}</span>
                                            </v-tooltip>

                                            <template v-else>
                                                <v-checkbox
                                                    label="Export normé définitif"
                                                    v-model="fecExportOptions.permanentFEC"
                                                    @click="onPermanentFecChange()"
                                                />
                                            </template>
                                        </v-col>

                                        <v-col cols="3">
                                            <v-tooltip
                                                v-if="!unexportedAccountingItemCount"
                                                location="top"
                                            >
                                                <template v-slot:activator="{ props }">
                                                    <div v-bind="props">
                                                        <v-checkbox
                                                            label="Non exportés"
                                                            v-model="
                                                                fecExportOptions.onlyNotExported
                                                            "
                                                            disabled
                                                            color="primary"
                                                        />
                                                    </div>
                                                </template>
                                                <span>Aucune écriture non exportée</span>
                                            </v-tooltip>

                                            <template v-else>
                                                <v-checkbox
                                                    label="Non exportés"
                                                    v-model="fecExportOptions.onlyNotExported"
                                                    @click="
                                                        fecExportOptions.permanentFEC = false;
                                                        fecDates();
                                                    "
                                                />
                                            </template>

                                            <!-- <v-select
                                                    v-model="accountingClosingSelected"
                                                    :items="accountingClosings"
                                                    :item-title="name"
                                                    return-object
                                                    label="Situation comptable"
                                                    class="oss- pr-1"
                                                    outlined
                                                    dense
                                                    :disabled="exportMode !== 1"
                                                ></v-select> -->
                                        </v-col>
                                        <v-col cols="4" class="px-1">
                                            <v-select-filled
                                                v-model="exportFileType"
                                                :items="exportFileTypeList"
                                                label="Export de fichier"
                                                hide-details
                                                item-title="text"
                                            />
                                        </v-col>
                                        <v-col cols="2" class="px-1">
                                            <v-select-filled
                                                v-model="fecExportOptions.extentionFile"
                                                :items="extentionFileList"
                                                label="Extension"
                                                hide-details
                                                item-title="text"
                                            />
                                        </v-col>
                                        <v-col cols="6" class="pr-1">
                                            <oss-date-picker-filled
                                                v-model="fecExportOptions.startDate"
                                                label="Date de début d'export"
                                                :mandatory="true"
                                                :textFieldReadOnly="false"
                                                :disabled="disabledDatePicker"
                                                :minDate="
                                                    accountingPeriod && accountingPeriod.start
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <oss-date-picker-filled
                                                v-model="fecExportOptions.endDate"
                                                label="Date de fin d'export"
                                                :mandatory="true"
                                                :textFieldReadOnly="false"
                                                :disabled="disabledDatePicker"
                                                :maxDate="accountingPeriod && accountingPeriod.end"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="pt-2">
                                            <v-divider />
                                        </v-col>
                                        <v-col cols="12" class="py-2"> Comptes auxiliaires </v-col>
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                v-model="fecExportOptions.supplierPrefix"
                                                label="Prefixe fournisseurs"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <v-text-field-filled
                                                v-model="fecExportOptions.customerPrefix"
                                                label="Préfixe clients"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-1">
                                            <oss-text-field-filled
                                                v-model="fecExportOptions.auxiliaryCharacterCount"
                                                label="Nombre de caractères"
                                                outlined
                                                dense
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12" class="pt-2">
                                            <v-divider />
                                        </v-col>
                                        <v-col cols="12" class="py-2">
                                            Comptes avec utilisateur
                                        </v-col>
                                        <v-col cols="12">
                                            <v-radio-group
                                                v-model="
                                                    fecExportOptions.accountableAccountWithUserAsSubAccount
                                                "
                                                inline
                                                color="primary"
                                            >
                                                <v-radio
                                                    label="Avec un compte auxiliaire"
                                                    :value="false"
                                                />
                                                <v-radio
                                                    label="Avec un sous compte"
                                                    data-cy="ExportAccounting-compte"
                                                    :value="true"
                                                />
                                            </v-radio-group>
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            v-if="
                                                !fecExportOptions.accountableAccountWithUserAsSubAccount
                                            "
                                        >
                                            <v-text-field-filled
                                                v-model="fecExportOptions.aa421Suffix"
                                                label="Prefixe salaire"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-2"
                                            v-if="
                                                !fecExportOptions.accountableAccountWithUserAsSubAccount
                                            "
                                        >
                                            <v-text-field-filled
                                                v-model="fecExportOptions.aa425Suffix"
                                                label="Préfixe note de frais"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-2"
                                            v-if="
                                                !fecExportOptions.accountableAccountWithUserAsSubAccount
                                            "
                                        >
                                            <v-text-field-filled
                                                v-model="fecExportOptions.aa455Suffix"
                                                label="Prefixe compte courant"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="pl-2"
                                            v-if="
                                                !fecExportOptions.accountableAccountWithUserAsSubAccount
                                            "
                                        >
                                            <v-text-field-filled
                                                v-model="fecExportOptions.aa467Suffix"
                                                label="Préfixe débiteur/créditeur"
                                                outlined
                                                hide-details
                                                density="compact"
                                            />
                                        </v-col>

                                        <v-col cols="12" class="pt-2">
                                            <v-divider />
                                        </v-col>
                                        <v-col cols="12" class="py-2">
                                            Ecritures journaux de banques
                                        </v-col>
                                        <v-col cols="12" class="pt-2">
                                            <v-select-filled
                                                v-model="fecExportOptions.bankPieceRef"
                                                :items="bankPieceRefs"
                                                label="Référence"
                                                class="pr-1"
                                                item-title="text"
                                            />
                                            <!-- <v-switch inset dense v-model="fecExportOptions.bankPieceRef" label="Ajouter une référence" class="pl-2"></v-switch> -->
                                        </v-col>
                                        <v-col cols="12" class="pt-2">
                                            <v-divider />
                                        </v-col>
                                        <v-col cols="6" class="pr-4">
                                            <v-row>
                                                <v-col>Comptes comptable</v-col>
                                            </v-row>
                                            <v-row no-gutters class="pt-1">
                                                <v-col>
                                                    <v-select-filled
                                                        v-model="
                                                            fecExportOptions.accountableAccountCharacterCount
                                                        "
                                                        :items="accountableAccountCharacterCounts"
                                                        label="Nombre de caractères"
                                                        hide-details
                                                        item-title="text"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="6" class="pr-2">
                                            <v-row>
                                                <v-col>Export</v-col>
                                            </v-row>
                                            <v-row no-gutters class="pt-1">
                                                <v-col cols="12">
                                                    <v-select-filled
                                                        v-model="fecExportOptions.softwareExport"
                                                        :items="softwareExportTypeList"
                                                        item-value="value"
                                                        label="Logiciel"
                                                        hide-details
                                                        @update:model-value="setFormatLimits()"
                                                        density="compact"
                                                        :item-title="(item) => item.text"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_fec_accountableAccounts">
                                <v-row no-gutters class="py-1">
                                    <v-col cols="6" class="pl-3">
                                        <h4>Correspondance de Comptes</h4>
                                    </v-col>
                                    <v-col cols="6" class="justify-center">
                                        <v-switch
                                            v-model="displayUnmappedAccountableAccounts"
                                            label="Afficher les éléments non mappés"
                                            hide-details
                                            class="mt-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-form
                                    ref="aaForm"
                                    v-model="isValidAccountableAccounts"
                                    lazy-validation
                                >
                                    <oss-data-table
                                        :dense="true"
                                        :headers="accAccHeaders"
                                        :items="filteredAccountableAccountItems"
                                        :items-per-page="-1"
                                        fixed-header
                                        :fixed-footer="true"
                                        :virtual-scroll="true"
                                        :table-hover="true"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template v-slot:item="props">
                                            <tr
                                                :style="
                                                    'background-color:' +
                                                    (props.item.description ? '' : '#F9B12A')
                                                "
                                            >
                                                <td class="text-left">{{ props.item.name }}</td>
                                                <td
                                                    v-if="props.item.missingDescription"
                                                    class="text-left"
                                                >
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex justify-center align-center"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.description"
                                                                class="py-1"
                                                                outlined
                                                                hide-details
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        $t('settings.itemRequired'),
                                                                ]"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </td>
                                                <td v-else class="pl-4 text-left">
                                                    {{ props.item.description }}
                                                </td>
                                                <td class="text-left">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex justify-center align-center"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.export"
                                                                class="py-1"
                                                                outlined
                                                                hide-details="auto"
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        $t('settings.itemRequired'),
                                                                    (v) =>
                                                                        v.length <=
                                                                            fecExportOptions.accountableAccountCharacterCount ||
                                                                        $t('settings.tooLong'),
                                                                ]"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </td>
                                            </tr>
                                        </template>
                                    </oss-data-table>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_fec_bankAccounts">
                                <v-row no-gutters class="py-1">
                                    <v-col cols="6" class="pl-3">
                                        <h4>Correspondance de Banques</h4>
                                    </v-col>
                                    <v-col cols="6" class="justify-center">
                                        <v-switch
                                            v-model="displayUnmappedBankAccounts"
                                            label="Afficher les éléments non mappés"
                                            hide-details
                                            class="mt-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-form ref="baForm" v-model="isValidBankAccounts" lazy-validation>
                                    <oss-data-table
                                        dense
                                        :headers="bankAccountHeaders"
                                        :items="filteredBankAccountItems"
                                        :items-per-page="-1"
                                        fixed-header
                                        :fixed-footer="true"
                                        :virtual-scroll="true"
                                        :table-hover="true"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template v-slot:item="props">
                                            <tr>
                                                <td class="text-left">{{ props.item.name }}</td>
                                                <td class="text-left">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex justify-center align-center"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.export"
                                                                outlined
                                                                hide-details="auto"
                                                                color="orange"
                                                                :messages="
                                                                    getBankAccountTruncatedColor(
                                                                        props.item.export,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    (v) =>
                                                                        !!v ||
                                                                        $t('settings.itemRequired'),
                                                                ]"
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </td>
                                            </tr>
                                        </template>
                                    </oss-data-table>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_fec_users">
                                <v-row no-gutters class="py-1">
                                    <v-col cols="6" class="pl-3">
                                        <h4>Correspondance de Utilisateurs</h4>
                                    </v-col>
                                    <v-col cols="6" class="justify-center">
                                        <v-switch
                                            v-model="displayUnmappedUsers"
                                            label="Afficher les éléments non mappés"
                                            hide-details
                                            class="mt-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-form
                                    ref="usersForm"
                                    v-model="isValidAccountableAccounts"
                                    lazy-validation
                                >
                                    <oss-data-table
                                        dense
                                        :headers="userHeaders"
                                        :items="filteredUserItems"
                                        :items-per-page="-1"
                                        fixed-header
                                        :fixed-footer="true"
                                        :virtual-scroll="true"
                                        :table-hover="true"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template v-slot:item="props">
                                            <tr>
                                                <td class="text-left">
                                                    {{ props.item.firstname }}
                                                </td>
                                                <td class="text-left">
                                                    {{ props.item.lastname }}
                                                </td>
                                                <td class="text-left">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex justify-center align-center"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.export"
                                                                outlined
                                                                hide-details="auto"
                                                                :rules="
                                                                    getFecExportTableRules(
                                                                        props.item.name,
                                                                    )
                                                                "
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </td>
                                            </tr>
                                        </template>
                                    </oss-data-table>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_fec_auxiliaires">
                                <v-row no-gutters class="py-1">
                                    <v-col cols="6" class="pl-3">
                                        <h4>Correspondance de Fournisseurs/Clients</h4>
                                    </v-col>
                                    <v-col cols="6" class="justify-center">
                                        <v-switch
                                            v-model="displayUnmappedAuxiliaries"
                                            label="Afficher les éléments non mappés"
                                            hide-details
                                            class="mt-0"
                                        />
                                    </v-col>
                                </v-row>
                                <v-form
                                    ref="auxForm"
                                    v-model="isValidAccountableAccounts"
                                    lazy-validation
                                >
                                    <oss-data-table
                                        dense
                                        :headers="auxiliaryHeaders"
                                        :items="filteredAuxiliaryItems"
                                        :items-per-page="-1"
                                        fixed-header
                                        :fixed-footer="true"
                                        :virtual-scroll="true"
                                        :table-hover="true"
                                        style="border: 1px #ededed solid"
                                    >
                                        <template v-slot:item="props">
                                            <tr>
                                                <td class="text-left">
                                                    {{ props.item.thirdPartyCompany }}
                                                </td>
                                                <td class="text-left">{{ props.item.type }}</td>
                                                <td class="text-left">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex justify-center align-center"
                                                        >
                                                            <v-text-field-filled
                                                                v-model="props.item.export"
                                                                outlined
                                                                hide-details="auto"
                                                                :rules="
                                                                    getFecExportTableRules(
                                                                        props.item.name,
                                                                    )
                                                                "
                                                                density="compact"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </td>
                                            </tr>
                                        </template>
                                    </oss-data-table>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_log">
                                <v-form v-model="isExportLogValid">
                                    <v-row no-gutters class="mt-1">
                                        <v-col cols="6" class="pr-1">
                                            <oss-date-picker-filled
                                                v-model="selectedLogs.startDate"
                                                label="Date de début d'export"
                                                :mandatory="true"
                                                :textFieldReadOnly="false"
                                                :disabled="disabledDatePicker"
                                                :minDate="
                                                    accountingPeriod && accountingPeriod.start
                                                "
                                                prefixDataCy="ExportAccounting-beginDate"
                                            />
                                            <!-- <v-text-field
                                                    :model-value="formatDate(selectedLogs.startDate)"
                                                    dense outlined hide-details
                                                    label="Date de début d'export"
                                                    @click="selectDate('logStart')"
                                                    class="oss-"
                                                    readonly
                                                ></v-text-field> -->
                                        </v-col>
                                        <v-col cols="6">
                                            <oss-date-picker-filled
                                                v-model="selectedLogs.endDate"
                                                label="Date de fin d'export"
                                                :mandatory="true"
                                                :textFieldReadOnly="false"
                                                :disabled="disabledDatePicker"
                                                :maxDate="accountingPeriod && accountingPeriod.end"
                                                prefixDataCy="ExportAccounting-endDate"
                                            />
                                            <!-- <v-text-field
                                                    :model-value="formatDate(selectedLogs.endDate)"
                                                    dense outlined hide-details
                                                    label="Date de fin d'export"
                                                    @click="selectDate('logEnd')"
                                                    class="oss-"
                                                    readonly
                                                ></v-text-field> -->
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-window-item>
                            <v-window-item value="export_log_1">
                                <!-- exportLog() -->
                                <v-row no-gutters class="d-flex justify-center">
                                    <v-col cols="8" class="pt-1">
                                        <span v-if="logList.global && !logList.global.length">
                                            Aucune donnée sur la periode
                                            {{ formatDate(selectedLogs.startDate) }} -
                                            {{ formatDate(selectedLogs.endDate) }}
                                        </span>

                                        <v-row no-gutters v-else>
                                            <v-col cols="12">
                                                <v-list-item
                                                    link
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                >
                                                    <v-checkbox
                                                        :input-value="allSelected"
                                                        :ripple="false"
                                                        :indeterminate="allSelectedIndeterminate"
                                                        @click="selectAll(allSelected)"
                                                        data-cy="ExportAccounting-allSelected"
                                                        :value="allSelected"
                                                    />

                                                    <v-list-item-title>
                                                        Tout sélectionner
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-col>
                                            <!-- <v-col cols="6" class="d-flex justify-center pb-1">
                                                    <v-btn
                                                        text
                                                         size="small"
                                                        @click="selectAll(false)"
                                                    >
                                                        <v-icon  size="small" left>$fa-square</v-icon>
                                                        Tout désélectionner
                                                    </v-btn>
                                                </v-col> -->
                                        </v-row>

                                        <v-list
                                            subheader
                                            v-if="
                                                logList && logList.global && logList.global.length
                                            "
                                        >
                                            <div
                                                v-for="(item, index) in logList.global"
                                                :key="index"
                                            >
                                                <v-list-group
                                                    v-if="item.type === 'PURCHASE_INVOICE'"
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                    :model-value="false"
                                                >
                                                    <template v-slot:activator>
                                                        <v-checkbox
                                                            v-model="selectedLogs.global"
                                                            :ripple="false"
                                                            :indeterminate="purchasesIndeterminate"
                                                            @click.stop="
                                                                selectLogListGlobal(item.type)
                                                            "
                                                            :value="item.type"
                                                        />

                                                        <v-list-item-title>
                                                            <b
                                                                >{{
                                                                    $t(
                                                                        "accountingItem.type." +
                                                                            item.type,
                                                                    )
                                                                }}
                                                            </b>
                                                            ({{ item.count }})
                                                        </v-list-item-title>
                                                    </template>

                                                    <template
                                                        v-if="
                                                            logList &&
                                                            logList.purchases &&
                                                            logList.purchases.length
                                                        "
                                                    >
                                                        <v-list-item
                                                            v-for="(purch, i) in logList.purchases"
                                                            :key="i"
                                                            link
                                                            :class="
                                                                !$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            "
                                                        >
                                                            <template #prepend>
                                                                <v-checkbox
                                                                    v-model="
                                                                        selectedLogs.purchaseThirdParty
                                                                    "
                                                                    :ripple="false"
                                                                    @click.stop="
                                                                        selectLogSubList(item.type)
                                                                    "
                                                                    :value="purch.id"
                                                                />
                                                            </template>
                                                            <v-list-item-title>
                                                                {{ purch.thirdParty }}
                                                                ({{ purch.count }})
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                </v-list-group>

                                                <v-list-group
                                                    v-else-if="item.type === 'SALES_INVOICE'"
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                    :model-value="false"
                                                >
                                                    <template v-slot:activator>
                                                        <v-checkbox
                                                            v-model="selectedLogs.global"
                                                            :ripple="false"
                                                            :indeterminate="salesIndeterminate"
                                                            @click.stop="
                                                                selectLogListGlobal(item.type)
                                                            "
                                                            :value="item.type"
                                                        />

                                                        <v-list-item-title>
                                                            <b
                                                                >{{
                                                                    $t(
                                                                        "accountingItem.type." +
                                                                            item.type,
                                                                    )
                                                                }}
                                                            </b>
                                                            ({{ item.count }})
                                                        </v-list-item-title>
                                                    </template>

                                                    <template
                                                        v-if="
                                                            logList &&
                                                            logList.sales &&
                                                            logList.sales.length
                                                        "
                                                    >
                                                        <v-list-item
                                                            v-for="(sale, i) in logList.sales"
                                                            :key="i"
                                                            link
                                                            :class="
                                                                !$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            "
                                                        >
                                                            <template #prepend>
                                                                <v-checkbox
                                                                    v-model="
                                                                        selectedLogs.salesThirdParty
                                                                    "
                                                                    :ripple="false"
                                                                    @click.stop="
                                                                        selectLogSubList(item.type)
                                                                    "
                                                                    :value="sale.id"
                                                                />
                                                            </template>

                                                            <v-list-item-title>
                                                                {{ sale.thirdParty }}
                                                                ({{ sale.count }})
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                </v-list-group>

                                                <v-list-group
                                                    v-else-if="item.type === 'BANK'"
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                    :model-value="false"
                                                >
                                                    <template #prepend>
                                                        <v-checkbox
                                                            v-model="selectedLogs.global"
                                                            :ripple="false"
                                                            :indeterminate="banksIndeterminate"
                                                            @click.stop="
                                                                selectLogListGlobal(item.type)
                                                            "
                                                            :value="item.type"
                                                        />
                                                    </template>

                                                    <v-list-item-title>
                                                        <b
                                                            >{{
                                                                $t(
                                                                    "accountingItem.type." +
                                                                        item.type,
                                                                )
                                                            }}
                                                        </b>
                                                        ({{ item.count }})
                                                    </v-list-item-title>

                                                    <template
                                                        v-if="
                                                            logList &&
                                                            logList.banks &&
                                                            logList.banks.length
                                                        "
                                                    >
                                                        <v-list-item
                                                            v-for="(b, i) in logList.banks"
                                                            :key="i"
                                                            link
                                                            :class="
                                                                !$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            "
                                                        >
                                                            <template #prepend>
                                                                <v-checkbox
                                                                    v-model="selectedLogs.banks"
                                                                    :ripple="false"
                                                                    @click.stop="
                                                                        selectLogSubList(item.type)
                                                                    "
                                                                    :value="b.id"
                                                                />
                                                            </template>

                                                            <v-list-item-title>
                                                                {{ b.name }}
                                                                ({{ b.count }})
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </template>
                                                </v-list-group>

                                                <v-list-item
                                                    v-else
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                >
                                                    <template #prepend>
                                                        <v-checkbox
                                                            v-model="selectedLogs.global"
                                                            :ripple="false"
                                                            :value="item.type"
                                                        />
                                                    </template>

                                                    <v-list-item-title>
                                                        <b
                                                            >{{
                                                                $t(
                                                                    "accountingItem.type." +
                                                                        item.type,
                                                                )
                                                            }}
                                                        </b>
                                                        ({{ item.count }})
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </div>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value> </v-window-item>
                            <v-window-item value="export_log_2">
                                <!-- exportLog() -->
                                <v-list subheader lines="two">
                                    <v-row>
                                        <v-checkbox
                                            v-model="exportWithProjectWatermark"
                                            :ripple="false"
                                            class="ml-1 mb-4"
                                            :title="$t('shared.exportWithProjectWatermark')"
                                            :label="$t('shared.exportWithProjectWatermark')"
                                        />
                                    </v-row>
                                    <v-list-item
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        :disabled="exportWithProjectWatermark"
                                        @click="exportFile('XLSX')"
                                        data-cy="ExportAccounting-excel"
                                    >
                                        <template #prepend>
                                            <v-icon color="secondary"> $fa-file-excel </v-icon>
                                        </template>
                                        <v-list-item-title>Excel</v-list-item-title>
                                        <v-list-item-subtitle
                                            >Exporter au format .xlsx</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        "
                                        @click="exportFile('DOCX')"
                                        data-cy="ExportAccounting-docx"
                                    >
                                        <template #prepend>
                                            <v-icon color="secondary"> $fa-file-word </v-icon>
                                        </template>
                                        <v-list-item-title>Docx</v-list-item-title>
                                        <v-list-item-subtitle
                                            >Exporter au format .docx</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        "
                                        @click="exportFile('PDF')"
                                        data-cy="ExportAccounting-PDF"
                                    >
                                        <template #prepend>
                                            <v-icon color="secondary"> $fa-file-pdf </v-icon>
                                        </template>

                                        <v-list-item-title>PDF</v-list-item-title>
                                        <v-list-item-subtitle
                                            >Exporter au format .pdf</v-list-item-subtitle
                                        >

                                        <template v-slot:append>
                                            <v-btn-next />
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-window-item>
                            <v-window-item value="date-picker">
                                <v-row no-gutters class="d-flex justify-center">
                                    <v-col cols="4" class="pt-1">
                                        <v-date-picker-wrapper
                                            v-model="dateSelected"
                                            color="secondary"
                                            first-day-of-week="1"
                                            scrollable
                                            full-width
                                            hide-header
                                            :landscape="!$vuetify.display.mobile"
                                        />
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="export_extensions">
                                <v-list-item
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    "
                                    v-for="ext of extensions"
                                    :key="ext.id"
                                    @click="
                                        step = 'display_extension';
                                        selectedExtension = ext;
                                    "
                                >
                                    <v-list-item-title>{{ ext.name }}</v-list-item-title>

                                    <template v-slot:append>
                                        <v-btn-next />
                                    </template>
                                </v-list-item>
                            </v-window-item>
                            <v-window-item value="display_extension">
                                <div style="height: 60vh" class="pa-1">
                                    <oss-widget-embedder
                                        v-if="selectedExtension"
                                        v-bind="selectedExtension"
                                        @close="step = 'export_extensions'"
                                    />
                                </div>
                            </v-window-item>
                            <v-window-item value="export_office_1">
                                <v-row no-gutters class="d-flex justify-center">
                                    <v-col cols="10" class="py-2">
                                        <v-list style="background: transparent">
                                            <v-list-item
                                                v-for="(item, index) in exportOfficeList"
                                                :key="index"
                                                ripple
                                                class="ma-1 oss-list-item"
                                                @click="exportOfficeFile(item)"
                                            >
                                                <template #prepend>
                                                    <v-icon color="secondary">
                                                        {{
                                                            ["xlsx", "xls", "xlsm"].includes(
                                                                item.filename.split(".").pop(),
                                                            )
                                                                ? "$fa-file-excel"
                                                                : "$fa-file-word"
                                                        }}
                                                    </v-icon>
                                                </template>
                                                <v-list-item-title>
                                                    {{ item.name }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ "Fichier associé : " + item.filename }}
                                                </v-list-item-subtitle>
                                                <template v-slot:append>
                                                    <v-icon>$chevron_right</v-icon>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>

                        <template v-slot:actions>
                            <v-btn-primary
                                v-if="actionBtnShow"
                                :disabled="actionBtnDisabled"
                                rounded
                                block
                                @click="actionBtnFunction()"
                                data-cy="ExportAccounting-valid"
                                size="x-large"
                                >{{ actionBtnText }}</v-btn-primary
                            >
                        </template>
                    </oss-dialog>
                    <AccountingBooklet
                        v-model="accountingBookletDialog"
                        v-if="accountingBookletDialog"
                        @back="
                            accountingBookletDialog = false;
                            exportDialog = true;
                        "
                        @exportStarted="refresh()"
                    />
                </v-col>
                <!-- <v-col cols="2" class="pl-2">
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        v-if="currentUser.profile.configuration.accounting.write"
                        :disabled="!companyId || !accountingPeriod"
                        @click="exportLog"
                        :loading="exportLogLoading"
                    >
                        Export journal général
                    </v-btn>
                </v-col> -->
                <!-- <v-col cols="2" class="pl-2">
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        v-if="currentUser.profile.configuration.accounting.write"
                        :disabled="!companyId || !accountingPeriod"
                        @click="exportGeneralLedger"
                        :loading="exportGeneralLedgerLoading"
                    >
                        Export XLSX
                    </v-btn>
                </v-col> -->
                <!-- <v-col cols="2" class="pl-2">
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        v-if="currentUser.profile.configuration.accounting.write"
                        :disabled="!companyId || !accountingPeriod"
                        :loading="exportDocumentsLoading"
                        @click="exportDocumentDialog = true"
                    >
                        Export documents
                    </v-btn>
                    <oss-dialog v-model="exportDocumentDialog" title="Télécharger les documents" width="60%">
                            Voulez-vous télécharger les documents jamais exportés ou tous les documents
                        </template>
                        <template v-slot:actions>
                            <v-row no-gutters>
                                <v-col cols="6" class="pr-2">
                                    <v-btn
                                        class="rounded-lg gradient"
                                        rounded
                                         size="small"
                                        block
                                         size=“x-large”
                                        elevation="0"

                                        @click="exportDocumentDialog = false ; exportDocuments(true)"
                                        :disabled="!unexportedAccountingItemCount"
                                    >Uniquement les documents jamais exportés</v-btn>
                                </v-col>
                                <v-col cols="6" class="pl-2">
                                    <v-btn
                                        class="rounded-lg gradient"
                                        rounded
                                         size="small"
                                        block
                                         size=“x-large”
                                        elevation="0"

                                        @click="exportDocumentDialog = false ; exportDocuments(false)"
                                    >Tout les documents</v-btn>
                            </v-col>
                        </v-row>
                    </oss-dialog>
                </v-col> -->
            </v-row>
            <v-data-table-server
                :headers="exportHeaders"
                :items="accountingItemExports"
                v-model:page="paginationExport.page"
                v-model:sort-by="paginationExport.sortBy"
                v-model:items-per-page="paginationExport.rowsPerPage"
                :items-per-page-options="[5, 10, 25]"
                :items-length="paginationExport.totalItems"
                class="table"
                fixed-header
                max-height="60vh"
            >
                <template v-slot:item="{ item }">
                    <tr style="cursor: pointer">
                        <td>
                            {{ item.name }}
                        </td>
                        <td>
                            <v-icon
                                v-if="item.status === 'EXPORTED_WITH_ERRORS'"
                                color="error"
                                size="small"
                                location="start"
                                >$fa-times</v-icon
                            >
                            {{ $t(`accountingItemExport.status.${item.status}`) }}
                            <v-progress-linear
                                height="10"
                                buffer-value="0"
                                v-if="item.status.startsWith('RUNNING') && item.stepCount"
                                stream
                                :model-value="(100 * item.step) / item.stepCount"
                            />
                        </td>
                        <td>
                            {{ getAccountingPeriodTitle(item) }}
                        </td>
                        <!-- <td style="text-align: center" class="px-0 text-center"
                            v-else>
                           <v-icon color="primary" size="large">$dot</v-icon>
                        </td> -->
                        <td>
                            {{ formatDateAndTime(item.updatedAt || item.createdAt) }}
                        </td>
                        <!-- <td class="text-center"
                        >
                            <v-btn
                                text
                                color="primary"
                                @click.stop="show(item)"
                            >
                            <v-icon  size="small">$fa-eye</v-icon>
                            </v-btn>
                        </td> -->
                        <td class="text-center">
                            <v-btn-trash
                                @click.stop="openDeleteDialog(item.id)"
                                :disabled="deleteDisabled(item)"
                                :data-cy="'ExportAccounting-delete-' + item.id"
                                size="small"
                            >
                            </v-btn-trash>
                        </td>
                        <td class="text-center">
                            <v-btn-icon
                                icon="$fa-cloud-download-alt"
                                color="secondary"
                                :disabled="!item.file"
                                @click.stop="directDownload(item)"
                                :data-cy="'ExportAccounting-download-' + item.id"
                            />
                            <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$fa-share"
                                        v-bind="props"
                                        color="secondary"
                                        :disabled="
                                            !item.file ||
                                            !!(
                                                item.file.originalDocuments &&
                                                item.file.originalDocuments.length
                                            )
                                        "
                                        :data-cy="'ExportAccounting-publier-' + item.id"
                                        @click.stop="publish(item)"
                                    />
                                </template>
                                <span> Partager au client </span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table-server>

            <oss-dialog
                v-model="deleteAccountingItemExportDialog"
                title="Supprimer"
                :error="true"
                @valid="deleteEditAccountingItemExport"
                :validLoading="deleteAccountingItemExportLoading"
                prefixDataCy="ExportAccounting-validDelete"
                width="800px"
            >
                <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer l'export ?</h4>
            </oss-dialog>

            <GeneralLedgerExportDialog
                v-if="exportGeneralLedgerDialog"
                v-model:exportGeneralLedgerDialog="exportGeneralLedgerDialog"
                :companyId="companyId"
                :accountingPeriodId="accountingPeriod.id"
                :fromExportAccounting="true"
                :accountableAccountsSelected="undefined"
                @exportFileFinished="onExportFileFinished"
                data-cy="ExportAccounting-telechargement"
            />
        </template>
    </v-container>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";
import { User } from "../store/store";

import moment from "moment-timezone";
import _ from "lodash";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import EXPORT_FEC_QUERY from "../graphql/accountingItem/ExportAccountingFEC.gql";
import EXPORT_LOG_QUERY from "../graphql/accountingItem/ExportAccountingLog.gql";
// import EXPORT_GENERAL_LEDGER_QUERY from "../graphql/accountingItem/ExportGeneralLedger.gql";
import EXPORT_FEC_OPTIONS from "../graphql/accountingItem/ExportFECOptions.gql";
import ACCOUNTING_ITEM_EXPORTS from "../graphql/accountingItem/AccountingItemExports.gql";
import DELETE_ACCOUNTING_ITEM_EXPORT from "../graphql/accountingItem/DeleteAccountingItemExport.gql";
import UNEXPORTED_FILES_COUNT from "../graphql/accountingItem/UnExportedFilesCount.gql";
import LOG_LIST from "../graphql/accountingItem/LogList.gql";
import EXPORT_OFFICE_LIST from "../graphql/exportOffice/ExportOfficeProd.gql";
import EXPORT_OFFICE_FILE from "../graphql/exportOffice/ExportOfficeFile.gql";
import SHARE_EXPORT from "@/graphql/accountingItem/ShareExport.gql";
import EXTENSIONS_LIST from "@/graphql/extension/ExtentionsContext.gql";

import AccountingBooklet from "./dashboardAccounting/AccountingBooklet.vue";
import { NotificationBase } from "./NotificationBase";
import GeneralLedgerExportDialog from "./GeneralLedgerExportDialog.vue";
import OssWidgetEmbedder from "./ossComponents/ossWidgetEmbedder.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";

import getEnv from "../env";
import { getDBFormattedDate } from "../services/dateServices";
import { ExportFECServices } from "../../../backend/src/common/export/exportFEC";
import softwareExportFormats from "../../../backend/src/common/export/softwareExportFormats.json";
import { checkAccessRights } from "../services/accessRightServices";

import { Offer_type } from "@/types/offer.types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        AccountingBooklet,
        GeneralLedgerExportDialog,
        OssWidgetEmbedder,
        OssDataTable,
    },
})
export class ExportAccounting extends NotificationBase {
    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod!: any;

    @State2Way("updateSelectedAccountingClosing", "accountingPeriod.selectedAccountingClosing")
    accountingClosing!: any;

    headers = [];

    fec: String = "";

    exportHeaders: Array<any> = [
        { title: "Nom", value: "name", align: "left", sortable: true },
        { title: "Statut", value: "status", align: "left", sortable: true },
        { title: "Période", value: "accountingPeriod", align: "left", sortable: false },
        { title: "Dernière modification", value: "updatedAt", align: "left", sortable: true },
        // { title: "Voir", value: '', align: 'center', sortable: false },
        { title: "Supprimer", value: "", align: "center", sortable: false },
        { title: "Télécharger", value: "", align: "center", sortable: false },
    ];

    get isTrainingOffer() {
        if (this.offerType === Offer_type.TRAINING) {
            return true;
        }
        return false;
    }

    paginationExport: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: ["updatedAt"],
        descending: [true],
        totalItems: 100,
    };

    errorHeaders = [
        { text: "Type", value: "type" },
        { text: "Erreur", value: "error" },
        { text: "Id", value: "id" },
    ];

    errors = [];

    auxiliaryHeaders = [
        { text: "Tiers (bobbee)", value: "thirdParty", sortable: true, align: "left" },
        { text: "Type", value: "type", sortable: true, align: "left" },
        { text: "Tiers (export)", value: "export", sortable: false, align: "left" },
    ];

    userHeaders = [
        { text: "Nom", value: "firstname", sortable: true, align: "left" },
        { text: "Prénom", value: "lastname", sortable: true, align: "left" },
        { text: "Export", value: "export", sortable: false, align: "left" },
    ];

    accAccHeaders = [
        { text: "Nom (bobbee)", value: "name", sortable: true, align: "left" },
        { text: "Description", value: "type", sortable: true, align: "left" },
        { text: "Nom (export)", value: "export", sortable: false, align: "left" },
    ];

    bankAccountHeaders = [
        { text: "Nom (bobbee)", value: "name", sortable: true, align: "left" },
        { text: "Nom (export)", value: "export", sortable: false, align: "left" },
    ];

    auxiliaryItems = [];
    userItems = [];
    accountableAccountItems = [];
    bankAccountItems = [];
    journalLibMaxChar = 1000;

    isValidAccountableAccounts = true;
    isValidBankAccounts = true;
    isValidUsers = true;
    isValidAuxiliaries = true;

    displayUnmappedAccountableAccounts = true;
    displayUnmappedBankAccounts = true;
    displayUnmappedUsers = true;
    displayUnmappedAuxiliaries = true;

    exportDocument = [
        { text: "Aucun document", value: "NO_DOCUMENTS" },
        { text: "Uniquement les documents non-exportés", value: "NOT_EXPORTED_ONLY" },
        { text: "Tout les documents", value: "ALL_DOCUMENTS" },
    ];

    formatExport = [
        { text: "Excel", value: "XLSX" },
        { text: "Word", value: "DOCX" },
        { text: "PDF", value: "PDF" },
    ];

    exportWithProjectWatermark = false;

    get accountableAccountCharacterCounts() {
        const countArray = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
        const index = countArray.indexOf(this.fecExportOptions.minAccountableAccountCharacterCount);
        if (index > 0) {
            return countArray.slice(0, index);
        }
        return countArray;
    }

    get offerType() {
        return this.$store?.state?.offerType;
    }

    get isUserHasAccess() {
        return this.$store?.getters?.isUserHasAccess();
    }

    get isAllowedTo() {
        // if (this.offerType) {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        // }
        // return true;
        return checkAccessRights(
            this.currentUser,
            "accounting",
            "export",
            true,
            "isAllowedToAccounting",
        );
    }

    getBankAccountTruncatedColor(name) {
        if (name.length > this.journalLibMaxChar) {
            return "Le nom sera tronqué à " + this.journalLibMaxChar.toString() + "caractères";
        }
        return undefined;
    }

    exportFileTypeList = [
        { text: "Sans les documents", value: "withoutFiles" },
        { text: "Avec les documents originaux", value: "withOriginalFiles" },
        { text: "Avec les documents en PDF", value: "withConvertedFiles" },
    ];

    softwareExportTypeList = [
        { text: "Inconnu", value: "unknown" },
        { text: "Quadratus", value: "quadratus", disabled: false },
        { text: "Cegid Expert", value: "cegid_expert", disabled: false },
        { text: "Coala ", value: "coala" },
        { text: "ACD Cador", value: "acd" },
        { text: "Agiris", value: "agiris", disabled: false },
        { text: "MyUnisoft", value: "my_unisoft", disabled: false },
        { text: "Loop", value: "loop", disabled: false },
        { text: "Inqom", value: "inqom" },
        { text: "Tiime Expert", value: "tiime_expert" },
    ];

    get extentionFileList() {
        if (this.exportFileType !== "withoutFiles") {
            if (
                ["loop", "my_unisoft", "cegid_expert"].includes(
                    this.fecExportOptions.softwareExport,
                )
            ) {
                this.fecExportOptions.extentionFile = "TRA";
                return { text: ".tra", value: "TRA" };
            }
            if (["quadratus"].includes(this.fecExportOptions.softwareExport)) {
                this.fecExportOptions.extentionFile = "ASCII";
                return { text: ".ascii", value: "ASCII" };
            }
        }
        const extentions = [
            { text: ".tsv", value: "TSV" },
            { text: ".txt", value: "TXT" },
            { text: ".csv", value: "CSV" },
            { text: ".psv (|)", value: "PSV" },
            { text: ".ssv (;)", value: "SSV" },
        ];
        if (
            ["my_unisoft", "loop", "inqom", "cegid_expert"].includes(
                this.fecExportOptions.softwareExport,
            )
        ) {
            this.fecExportOptions.extentionFile = "TRA";
            extentions.push({ text: ".tra", value: "TRA" });
        } else if (["quadratus"].includes(this.fecExportOptions.softwareExport)) {
            this.fecExportOptions.extentionFile = "ASCII";
            extentions.push({ text: ".ascii", value: "ASCII" });
        } else if (["coala"].includes(this.fecExportOptions.softwareExport)) {
            this.fecExportOptions.extentionFile = "TXT";
        } else {
            this.fecExportOptions.extentionFile = "TSV";
        }
        return extentions;
    }

    defaultFecExportOptions = {
        supplierPrefix: "A_",
        customerPrefix: "V_",
        aa421Suffix: "PA_",
        aa425Suffix: "ND_",
        aa455Suffix: "CO_",
        aa467Suffix: "DC_",
        auxiliaryCharacterCount: 10,
        includeDocuments: false,
        convertInPDF: false,
        onlyNotExported: false,
        permanentFEC: false,
        startDate: "",
        endDate: "",
        extentionFile: "TSV",
        accountableAccountCharacterCount: 9,
        minAccountableAccountCharacterCount: 6,
        accountableAccountWithUserAsSubAccount: false,
        bankPieceRef: "",
        accountableAccounts: {},
        users: {},
        auxiliaries: {},
        bankAccounts: {},
        softwareExport: "unknown",
    };

    generalLedgerExportThirdParty: boolean = false;

    bankPieceRefs = [
        {
            value: "",
            text: "Pas de référence",
        },
        {
            value: "oneByMonth",
            text: "Une référence par mois",
        },
        {
            value: "oneByBankTransaction",
            text: "Une référence par transaction",
        },
    ];

    fecExportOptions = _.cloneDeep(this.defaultFecExportOptions);

    selectedLogs: any = {
        startDate: "",
        endDate: "",
        format: "PDF",
        global: [],
        purchaseThirdParty: [],
        salesThirdParty: [],
        banks: [],
        themeId: "bobbeeExportThemeId",
    };

    exportFECLoading: boolean = false;
    exportLogLoading: boolean = false;
    exportGeneralLedgerLoading: boolean = false;
    exportDocumentsLoading: boolean = false;

    toDeleteAccountingItemExportId = "";
    deleteAccountingItemExportLoading: boolean = false;
    deleteAccountingItemExportDialog: boolean = false;

    activeTab: string = "AccountingItemExports";

    exportDocumentDialog: boolean = false;
    exportDialog: boolean = false;
    exportGeneralLedgerDialog: boolean = false;

    isExportFECValid: boolean = false;
    isExportLogValid: boolean = false;

    accountingBookletDialog = false;

    tooltipMessage: string = undefined;

    accountableAccountCharBlocked: boolean = false;
    auxiliaryAccountCharBlocked: boolean = false;

    noExportFecData: boolean = false;

    get allSelected() {
        if (
            this.selectedLogs?.global &&
            this.logList?.global &&
            this.selectedLogs.global.length === this.logList.global.length
        ) {
            if (
                !this.purchasesIndeterminate &&
                !this.salesIndeterminate &&
                !this.banksIndeterminate
            ) {
                return true;
            }
        }
        return false;
    }

    get defaultStep() {
        return this.isAllowedTo ? "default" : "export_fec";
    }

    step = this.defaultStep;

    selectedDateInput = this.defaultStep;

    get currentUser(): User {
        return this.$store?.state?.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "export");
        return authorized;
    }

    get companyId() {
        return this.$store?.state?.selected_company?.id;
    }

    get selectedCompany() {
        return this.$store?.state?.selected_company;
    }

    get purchasesIndeterminate() {
        if (
            this.selectedLogs?.purchaseThirdParty?.length &&
            this.logList?.purchases?.length &&
            this.selectedLogs.purchaseThirdParty.length !== this.logList.purchases.length
        ) {
            return true;
        }
        return false;
    }

    get salesIndeterminate() {
        if (
            this.selectedLogs?.salesThirdParty?.length &&
            this.logList?.sales?.length &&
            this.selectedLogs.salesThirdParty.length !== this.logList.sales.length
        ) {
            return true;
        }
        return false;
    }

    get banksIndeterminate() {
        if (
            this.selectedLogs?.banks?.length &&
            this.logList?.banks?.length &&
            this.selectedLogs.banks.length !== this.logList.banks.length
        ) {
            return true;
        }
        return false;
    }

    get allSelectedIndeterminate() {
        if (this.purchasesIndeterminate || this.salesIndeterminate || this.banksIndeterminate) {
            return true;
        }
        if (
            this.selectedLogs?.global?.length &&
            this.logList?.global?.length &&
            this.selectedLogs.global.length !== this.logList.global.length
        ) {
            return true;
        }
        return false;
    }

    get actionBtnShow() {
        switch (this.step) {
            case "default":
                return false;
            case "export_log_2":
                return false;
            case "export_office_1":
                return false;
            case "display_extension":
                return false;
            case "export_extensions":
                return false;
            default:
                return true;
        }
    }

    get actionBtnDisabled() {
        switch (this.step) {
            case "default":
                return false;
            case "export_fec_general":
                return !this.isExportFECValid || this.noExportFecData;
            case "export_fec_accountableAccounts":
                return this.accountableAccountItems.some((aa) => aa.description === "");
            case "export_log":
                return !this.isExportLogValid;
            case "export_log_1":
                return !(this.logList?.global?.length && this.selectedLogs?.global?.length);
            default:
                return false;
        }
    }

    get actionBtnText() {
        switch (this.step) {
            case "export_fec_general":
                return "Suivant";
            case "export_fec_accountableAccounts":
                return "Suivant";
            case "export_fec_users":
                return "Suivant";
            case "export_fec_bankAccounts":
                return "Suivant";
            case "export_fec_auxiliaires":
                return "Valider";
            case "export_log":
                return "Suivant";
            case "export_log_1":
                return "Suivant";
            case "date-picker":
                return "Valider";
            default:
                return "";
        }
    }

    get exportFileType() {
        if (this.fecExportOptions.includeDocuments && this.fecExportOptions.convertInPDF) {
            return "withConvertedFiles";
        }
        if (this.fecExportOptions.includeDocuments && !this.fecExportOptions.convertInPDF) {
            return "withOriginalFiles";
        }
        return "withoutFiles";
    }

    set exportFileType(data) {
        switch (data) {
            case "withConvertedFiles": {
                this.fecExportOptions.includeDocuments = true;
                this.fecExportOptions.convertInPDF = true;
                break;
            }
            case "withOriginalFiles": {
                this.fecExportOptions.includeDocuments = true;
                this.fecExportOptions.convertInPDF = false;
                break;
            }
            case "withoutFiles": {
                this.fecExportOptions.includeDocuments = false;
                this.fecExportOptions.convertInPDF = false;
                break;
            }
            default: {
                this.fecExportOptions.includeDocuments = false;
                this.fecExportOptions.convertInPDF = false;
                break;
            }
        }
    }

    get filteredAccountableAccountItems() {
        if (this.accountableAccountItems.length) {
            if (this.displayUnmappedAccountableAccounts) {
                return this.accountableAccountItems.filter((x) => (x.mapped = false));
            } else {
                return this.accountableAccountItems;
            }
        }
        return [];
    }

    get filteredBankAccountItems() {
        if (this.bankAccountItems.length) {
            if (this.displayUnmappedBankAccounts) {
                return this.bankAccountItems.filter((x) => (x.mapped = false));
            } else {
                return this.bankAccountItems;
            }
        }
        return [];
    }

    get filteredUserItems() {
        if (this.userItems.length) {
            if (this.displayUnmappedUsers) {
                return this.userItems.filter((x) => x.mapped === false);
            } else {
                return this.userItems;
            }
        }
        return [];
    }

    get filteredAuxiliaryItems() {
        if (this.auxiliaryItems.length) {
            if (this.displayUnmappedAuxiliaries) {
                return this.auxiliaryItems.filter((x) => x.mapped === false);
            } else {
                return this.auxiliaryItems;
            }
        }
        return [];
    }

    previousStep() {
        switch (this.step) {
            case "export_fec_accountableAccounts":
                this.step = "export_fec_general";
                break;
            case "export_fec_bankAccounts":
                this.step = "export_fec_accountableAccounts";
                break;
            case "export_fec_users":
                this.step = "export_fec_bankAccounts";
                break;
            case "export_fec_auxiliaires":
                if (!this.fecExportOptions.accountableAccountWithUserAsSubAccount) {
                    this.step = "export_fec_users";
                } else {
                    this.step = "export_fec_bankAccounts";
                }
                break;

            default:
                this.step = this.defaultStep;
                break;
        }
    }

    @Watch("step")
    setDatesToAccountingClosing() {
        if (this.step === "export_log" && this.accountingClosing?.id) {
            this.selectedLogs.startDate = moment(this.accountingPeriod.start).format("YYYY-MM-DD");
            this.selectedLogs.endDate = moment(this.accountingClosing.endDate).format("YYYY-MM-DD");
        }
    }

    // @Watch("accountingBookletDialog")
    // closeDialog() {
    //     if (this.accountingBookletDialog) {
    //         this.exportDialog = false;
    //     } else {
    //         this.refresh();
    //     }
    // }

    @Watch("fecExportOptions", { deep: true })
    modifyDates() {
        if (this.fecExportOptions.startDate) {
            this.selectedLogs.startDate = this.fecExportOptions.startDate;
        }
        if (this.fecExportOptions.endDate) {
            this.selectedLogs.endDate = this.fecExportOptions.endDate;
        }
    }

    selectAll(value) {
        if (!value && this.logList) {
            if (this.logList.global)
                this.selectedLogs.global = this.logList.global.map((x) => x.type) || [];
            if (this.logList.purchases)
                this.selectedLogs.purchaseThirdParty =
                    this.logList.purchases.filter((x) => !!x.id).map((x) => x.id) || [];
            if (this.logList.sales)
                this.selectedLogs.salesThirdParty =
                    this.logList.sales.filter((x) => !!x.id).map((x) => x.id) || [];
            if (this.logList.banks)
                this.selectedLogs.banks = this.logList.banks.map((x) => x.id) || [];
        } else {
            this.selectedLogs.global = [];
            this.selectedLogs.purchaseThirdParty = [];
            this.selectedLogs.salesThirdParty = [];
            this.selectedLogs.banks = [];
        }
    }

    async actionBtnFunction() {
        switch (this.step) {
            case "export_fec_general":
                this.step = "export_fec_accountableAccounts";
                if (this.accountableAccountItems.some((aa) => aa.description === "")) {
                    this.displayUnmappedAccountableAccounts = false;
                }
                this.calculateFECWordings();
                break;
            case "export_fec_accountableAccounts":
                //@ts-ignore
                if (this.$refs.aaForm.validate()) {
                    this.step = "export_fec_bankAccounts";
                }
                break;
            case "export_fec_bankAccounts":
                //@ts-ignore
                if (this.$refs.baForm.validate()) {
                    if (this.fecExportOptions.accountableAccountWithUserAsSubAccount) {
                        this.step = "export_fec_auxiliaires";
                    } else {
                        this.step = "export_fec_users";
                    }
                }
                break;
            case "export_fec_users":
                //@ts-ignore
                if (this.$refs.usersForm.validate()) {
                    this.step = "export_fec_auxiliaires";
                }
                break;
            case "export_fec_auxiliaires":
                //@ts-ignore
                if (this.$refs.auxForm.validate()) {
                    this.exportDialog = false;
                    await this.exportFEC();
                    this.resetDialog();
                }
                break;
            case "export_log":
                this.step = "export_log_1";
                break;
            case "export_log_1":
                this.step = "export_log_2";
                break;
            case "date-picker":
                if (this.selectedDateInput === "logStart") {
                    this.step = "export_log";
                }
                if (this.selectedDateInput === "logEnd") {
                    this.step = "export_log";
                }
                if (this.selectedDateInput === "fecStart") {
                    this.step = "export_fec_general";
                }
                if (this.selectedDateInput === "fecEnd") {
                    this.step = "export_fec_general";
                }
                break;
            default:
                return true;
        }
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    formatDateYYYYMMDD(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("YYYYMMDD");
    }

    formatDateAndTime(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).local().format("DD/MM/YYYY - HH:mm");
    }

    emptyFunction() {}

    selectDate(value) {
        this.selectedDateInput = value;
        this.step = "date-picker";
    }

    get dateSelected() {
        switch (this.selectedDateInput) {
            case "logStart":
                return this.selectedLogs.startDate
                    ? moment(this.selectedLogs.startDate).format("YYYY-MM-DD")
                    : "";
            case "logEnd":
                return this.selectedLogs.endDate
                    ? moment(this.selectedLogs.endDate).format("YYYY-MM-DD")
                    : "";
            case "fecStart":
                return this.fecExportOptions.startDate
                    ? moment(this.fecExportOptions.startDate).format("YYYY-MM-DD")
                    : "";
            case "fecEnd":
                return this.fecExportOptions.endDate
                    ? moment(this.fecExportOptions.endDate).format("YYYY-MM-DD")
                    : "";
        }
    }

    set dateSelected(dateRange) {
        switch (this.selectedDateInput) {
            case "logStart":
                this.selectedLogs.startDate = dateRange;
                break;
            case "logEnd":
                this.selectedLogs.endDate = dateRange;
                break;
            case "fecStart":
                this.fecExportOptions.startDate = dateRange;
                break;
            case "fecEnd":
                this.fecExportOptions.endDate = dateRange;
                break;
        }
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAccountingPeriodTitle(item) {
        let text = "";
        if (item.startDate) {
            text += "Du " + moment(item.startDate).format("DD/MM/YYYY");
        }
        if (item.endDate) {
            if (text) {
                text += " au ";
            } else {
                text += "Jusqu'au ";
            }
            text += moment(item.endDate).format("DD/MM/YYYY");
        }
        if (text) {
            return text;
        }
        if (item.accountingPeriod) {
            text += "Du " + moment(item.accountingPeriod.start).format("DD/MM/YYYY");
            text += " au ";
            if (item.accountingClosing) {
                text += moment(item.accountingClosing.endDate).format("DD/MM/YYYY");
            } else {
                text += moment(item.accountingPeriod.end).format("DD/MM/YYYY");
            }
        }
        return text;
    }

    @Apollo({
        query: LOG_LIST,
        variables() {
            return {
                companyId: this.companyId,
                startDate: getDBFormattedDate(this.selectedLogs.startDate),
                endDate: getDBFormattedDate(this.selectedLogs.endDate),
            };
        },
        skip() {
            return (
                !this.isAuthorized ||
                !this.companyId ||
                !this.selectedLogs.startDate ||
                !this.selectedLogs.endDate
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.logList && data.logList.logList) {
                    this.selectAll(true);
                    this.logList = data.logList.logList;
                    this.selectAll(false);
                }
            }
        },
    })
    logList: any = {};

    @Apollo({
        query: EXPORT_OFFICE_LIST,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.exportOfficeProd?.exportsOffice?.length) {
                    this.exportOfficeList = data.exportOfficeProd.exportsOffice;
                }
            }
        },
    })
    exportOfficeList: any = [];

    @Apollo({
        query: ACCOUNTING_ITEM_EXPORTS,
        variables() {
            return {
                companyId: this.companyId,
                first:
                    this.paginationExport.rowsPerPage > 0 ? this.paginationExport.rowsPerPage : 100,
                skip: this.paginationExport.rowsPerPage * (this.paginationExport.page - 1),
                orderBy: this.formatOrderByExport(),
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.isAuthorized || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.accountingItemExports) {
                        this.accountingItemExports = data.accountingItemExports;
                    } else {
                        this.accountingItemExports = [];
                    }
                    if (
                        data.accountingItemExportsConnection &&
                        data.accountingItemExportsConnection.aggregate &&
                        data.accountingItemExportsConnection.aggregate.count !== null
                    ) {
                        this.paginationExport.totalItems =
                            data.accountingItemExportsConnection.aggregate.count;
                    } else {
                        this.paginationExport.totalItems = 0;
                    }
                    // this.subscribe()
                }
            }
        },
    })
    accountingItemExports: any[] = [];

    @Apollo({
        query: EXPORT_FEC_OPTIONS,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriod.id,
                accountingClosingId: this.accountingClosing?.id || undefined,
                startDate: getDBFormattedDate(this.fecExportOptions.startDate),
                endDate: getDBFormattedDate(this.fecExportOptions.endDate),
                onlyNotExported: this.fecExportOptions.onlyNotExported,
            };
        },
        skip() {
            return (
                !this.step.startsWith("export_fec") || !this.companyId || !this.accountingPeriod?.id
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.noExportFecData = false;
                    if (data.exportFECOptions) {
                        this.exportMappingFEC = data.exportFECOptions;
                        if (
                            !data.exportFECOptions.accountableAccounts.length &&
                            !data.exportFECOptions.thirdPartyCompanies.length &&
                            !data.exportFECOptions.bankAccounts.length
                        ) {
                            this.noExportFecData = true;
                        } else {
                            if (data.exportFECOptions.options.customerPrefix) {
                                this.fecExportOptions.customerPrefix =
                                    data.exportFECOptions.options.customerPrefix;
                                this.fecExportOptions.supplierPrefix =
                                    data.exportFECOptions.options.supplierPrefix;
                                this.fecExportOptions.aa421Suffix =
                                    data.exportFECOptions.options.aa421Suffix;
                                this.fecExportOptions.aa425Suffix =
                                    data.exportFECOptions.options.aa425Suffix;
                                this.fecExportOptions.aa455Suffix =
                                    data.exportFECOptions.options.aa455Suffix;
                                this.fecExportOptions.aa467Suffix =
                                    data.exportFECOptions.options.aa467Suffix;
                                this.fecExportOptions.auxiliaryCharacterCount =
                                    data.exportFECOptions.options.auxiliaryCharacterCount;
                                this.fecExportOptions.accountableAccountWithUserAsSubAccount =
                                    data.exportFECOptions.options.accountableAccountWithUserAsSubAccount;
                                this.fecExportOptions.accountableAccountCharacterCount =
                                    data.exportFECOptions.options.accountableAccountCharacterCount;
                            }
                            if (data.exportFECOptions.options.minAccountableAccountCharacterCount) {
                                this.fecExportOptions.minAccountableAccountCharacterCount =
                                    data.exportFECOptions.options.minAccountableAccountCharacterCount;
                            }
                        }
                        this.calculateFECWordings();
                    }
                }
            }
        },
    })
    exportMappingFEC: any = {};

    onMessage(data) {
        console.log("ExportAccounting onMessage " + data.payload.step);
        if (data) {
            if (data.action === "create") {
                const accountingItemExport = this.accountingItemExports.find(
                    (aie) => aie.id === data.id,
                );
                if (!accountingItemExport) {
                    this.accountingItemExports.splice(0, 0, data.payload);
                }
            }
            if (data.action === "update") {
                const accountingItemExport = this.accountingItemExports.find(
                    (aie) => aie.id === data.id,
                );
                if (accountingItemExport) {
                    accountingItemExport.file = data.payload.file;
                    accountingItemExport.status = data.payload.status;
                    accountingItemExport.step = data.payload.step;
                    accountingItemExport.stepCount = data.payload.stepCount;
                    accountingItemExport.createdAt = data.payload.createdAt;
                    accountingItemExport.updatedAt = data.payload.updatedAt;
                }
            } else if (data.action === "delete") {
                const index = this.accountingItemExports.findIndex((aie) => aie.id === data.id);
                if (index !== -1) {
                    this.accountingItemExports.splice(index, 1);
                }
            }
        }
    }

    beforeMount() {
        if (this.accountingPeriod?.closed) {
            this.fecExportOptions.permanentFEC = true;
            // this.fecExportOptions.extentionFile = "TXT";
        }
        this.fecDates();
        this.addListener("accountingItemExport");
    }

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.accountingItemExports) {
            this.$apollo.queries.accountingItemExports.stop();
        }
        this.removeListener();
    }

    formatOrderByExport() {
        const fieldName = this.paginationExport.sortBy.length
            ? this.paginationExport.sortBy[0].key
            : "";
        if (fieldName) {
            const direction =
                this.paginationExport.descending.length && this.paginationExport.descending[0]
                    ? "_DESC"
                    : "_ASC";
            return fieldName + direction;
        }
        return undefined;
    }

    selectLogListGlobal(type) {
        if (this.selectedLogs.global?.length) {
            if (type === "PURCHASE_INVOICE") {
                if (this.selectedLogs.global.filter((x) => x === "PURCHASE_INVOICE").length) {
                    this.selectedLogs.purchaseThirdParty = [
                        ...this.logList.purchases.map((x) => x.id),
                    ];
                } else {
                    this.selectedLogs.purchaseThirdParty = [];
                }
            } else if (type === "SALES_INVOICE") {
                if (this.selectedLogs.global.filter((x) => x === "SALES_INVOICE").length) {
                    this.selectedLogs.salesThirdParty = [...this.logList.sales.map((x) => x.id)];
                } else {
                    this.selectedLogs.salesThirdParty = [];
                }
            } else if (type === "BANK") {
                if (this.selectedLogs.global.filter((x) => x === "BANK").length) {
                    this.selectedLogs.banks = [...this.logList.banks.map((x) => x.id)];
                } else {
                    this.selectedLogs.banks = [];
                }
            }
        }
    }

    async exportFEC() {
        this.exportFECLoading = true;

        const options = JSON.parse(JSON.stringify(this.fecExportOptions));

        options.startDate = getDBFormattedDate(options.startDate);
        options.endDate = getDBFormattedDate(options.endDate);

        const accountableAccounts = {};
        const users = {};
        const auxiliaries = {};
        const bankAccounts = {};
        this.accountableAccountItems.forEach((obj) => {
            accountableAccounts[obj.name] = obj.export;
        });
        this.userItems.forEach((obj) => {
            users[obj.displayName] = obj.export;
        });
        this.auxiliaryItems.forEach((obj) => {
            auxiliaries[obj.thirdPartyCompany] = obj.export;
        });
        this.bankAccountItems.forEach((obj) => {
            bankAccounts[obj.name] = obj.export;
        });

        if (this.companyId && this.accountingPeriod) {
            await this.$apollo.mutate({
                mutation: EXPORT_FEC_QUERY,
                variables: {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriod.id,
                    accountingClosingId: this.accountingClosing?.id || undefined,
                    options: {
                        ...options,
                        users: users,
                        auxiliaries: auxiliaries,
                        accountableAccounts: accountableAccounts,
                        bankAccounts: bankAccounts,
                    },
                },
            });
            this.refresh();
        }
        this.exportFECLoading = false;
    }

    async exportLog() {
        this.exportLogLoading = true;

        const options = JSON.parse(JSON.stringify(this.selectedLogs));
        options.startDate = getDBFormattedDate(options.startDate);
        options.endDate = getDBFormattedDate(options.endDate);
        options.watermark = this.exportWithProjectWatermark
            ? this.$t("shared.draft").toUpperCase()
            : undefined;

        if (options.global && options.global.length) {
            if (options.purchaseThirdParty && options.purchaseThirdParty.length) {
                if (options.global.findIndex((x) => x === "PURCHASE_INVOICE") === -1) {
                    options.global.push("PURCHASE_INVOICE");
                }
            }
            if (options.salesThirdParty && options.salesThirdParty.length) {
                if (options.global.findIndex((x) => x === "SALES_INVOICE") === -1) {
                    options.global.push("SALES_INVOICE");
                }
            }
        }

        await this.$apollo.mutate({
            mutation: EXPORT_LOG_QUERY,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriod.id,
                accountingClosingId: this.accountingClosing?.id || undefined,
                options,
            },
        });
        this.refresh();
        this.exportLogLoading = false;
    }

    //
    // general ledger
    //

    refresh() {
        if (this.$apollo.queries) {
            if (this.$apollo.queries.accountingItemExports) {
                this.$apollo.queries.accountingItemExports.refetch();
            }
            if (this.$apollo.queries.logList) {
                this.$apollo.queries.logList.refetch();
            }
        } else {
            debugger;
        }
    }

    // accountingClosingSelected = null

    // get accountingClosing() {
    //     this.accountingClosingSelected = this.$store.state.accountingPeriod.selectedAccountingClosing
    //     return this.$store.state.accountingPeriod.selectedAccountingClosing
    // }

    // get accountingClosings() {
    //     const _storedAccountingClosings = this.$store.state.accountingPeriod.selectedAccountingPeriod.accountingClosings
    //     if (_storedAccountingClosings) {
    //         const storedAccountingClosings = [{
    //             id: "",
    //             name: "Sans situation"
    //         }]
    //         storedAccountingClosings.push(..._storedAccountingClosings)
    //         this.accountingClosingSelected = this.$store.state.accountingPeriod.selectedAccountingClosing?.id ? this.$store.state.accountingPeriod.selectedAccountingClosing : storedAccountingClosings[0]
    //         return storedAccountingClosings
    //     }
    //     this.accountingClosingSelected = null
    //     return []
    // }

    // async exportGeneralLedger() {
    //     this.exportGeneralLedgerLoading = true
    //     await this.$apollo.mutate({
    //         mutation: EXPORT_GENERAL_LEDGER_QUERY,
    //         variables: {
    //             companyId: this.companyId,
    //             accountingPeriodId: this.accountingPeriod.id,
    //             accountingClosingId: this.accountingClosing?.id || undefined
    //         }
    //     });
    //     this.refresh();
    //     this.exportGeneralLedgerLoading = false
    // }

    async exportOfficeFile(item) {
        // this.exportGeneralLedgerLoading = true
        await this.$apollo.mutate({
            mutation: EXPORT_OFFICE_FILE,
            variables: {
                companyId: this.companyId,
                exportOfficeId: item.id,
                accountingPeriodId: this.accountingPeriod.id,
                // accountingClosingId: this.accountingClosing?.id || undefined
            },
        });
        this.exportDialog = false;
        this.resetDialog();
        this.refresh();
        // this.exportGeneralLedgerLoading = false
    }

    show(accountingItemExport) {}

    directDownload(item) {
        window.open(`${env.VUE_APP_BACKEND}/accountingItemExport/download/${item.id}`, "_blank");
    }

    async deleteEditAccountingItemExport() {
        if (this.toDeleteAccountingItemExportId) {
            this.deleteAccountingItemExportLoading = true;
            await this.$apollo
                .mutate({
                    mutation: DELETE_ACCOUNTING_ITEM_EXPORT,
                    variables: {
                        id: this.toDeleteAccountingItemExportId,
                    },
                })
                .catch((err) => {
                    debugger;
                });
            this.toDeleteAccountingItemExportId = "";
            this.deleteAccountingItemExportLoading = false;
            this.refresh();
        }
        this.deleteAccountingItemExportDialog = false;
    }

    deleteDisabled(item) {
        if (item.status.startsWith("RUNNING")) {
            if (moment().diff(item.updatedAt, "minutes") > 5) {
                return false;
            }
            return true;
        }
        if (item.notDeletable && item.accountingClosing?.id) {
            return true;
        }
        return false;
    }

    openDeleteDialog(id) {
        this.toDeleteAccountingItemExportId = id;
        this.deleteAccountingItemExportLoading = false;
        this.deleteAccountingItemExportDialog = true;
    }

    @Apollo({
        query: UNEXPORTED_FILES_COUNT,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriod.id,
                startDate: this.fecExportOptions.startDate
                    ? getDBFormattedDate(this.fecExportOptions.startDate)
                    : getDBFormattedDate(this.accountingPeriod.start),
                endDate: this.fecExportOptions.endDate
                    ? getDBFormattedDate(this.fecExportOptions.endDate)
                    : getDBFormattedDate(this.accountingPeriod.end),
            };
        },
        skip() {
            return (
                !this.isAuthorized ||
                !this.companyId ||
                !this.accountingPeriod?.id ||
                !this.exportDialog ||
                !this.step.startsWith("export_fec")
            );
        },
        specificResult({ data, loading, _ }: any) {
            if (!loading) {
                if (data && data.unexportedAccountingItemCount) {
                    this.unexportedAccountingItemCount =
                        data.unexportedAccountingItemCount.count || 0;
                }
            }
        },
    })
    unexportedAccountingItemCount = 0;

    resetDialog() {
        this.step = this.defaultStep;

        this.exportDialog = false;

        this.selectedLogs = {
            format: "PDF",
            global: [],
            purchaseThirdParty: [],
            salesThirdParty: [],
            banks: [],
        };

        this.fecExportOptions = _.cloneDeep(this.defaultFecExportOptions);

        this.fecDates();
        this.selectAll(false);
    }

    fecDates() {
        if (this.accountingPeriod?.closed && this.fecExportOptions.permanentFEC) {
            this.fecExportOptions.startDate = moment(this.accountingPeriod.start).format();
            this.fecExportOptions.endDate = moment(this.accountingPeriod.end).format();
            this.selectedLogs.startDate = moment(this.accountingPeriod.start).format();
            this.selectedLogs.endDate = moment(this.accountingPeriod.end).format();
        } else if (this.accountingClosing?.id) {
            this.fecExportOptions.startDate = moment(this.accountingPeriod.start).format();
            this.fecExportOptions.endDate = moment(this.accountingClosing.endDate).format();
            this.selectedLogs.startDate = moment(this.accountingPeriod.start).format();
            this.selectedLogs.endDate = moment(this.accountingClosing.endDate).format();
        } else if (this.accountingPeriod) {
            this.fecExportOptions.startDate = moment(this.accountingPeriod.start).format();
            this.fecExportOptions.endDate = moment(this.accountingPeriod.end).format();
            this.selectedLogs.startDate = moment(this.accountingPeriod.start).format();
            this.selectedLogs.endDate = moment(this.accountingPeriod.end).format();
        }
    }

    async exportFile(format) {
        this.selectedLogs.format = format;
        await this.exportLog();
        this.resetDialog();
    }

    selectLogSubList(type) {
        switch (type) {
            case "PURCHASE_INVOICE":
                if (
                    this.selectedLogs.purchaseThirdParty &&
                    this.selectedLogs.purchaseThirdParty.length
                ) {
                    if (!this.selectedLogs.global.includes(type)) {
                        this.selectedLogs.global.push(type);
                    }
                } else {
                    this.selectedLogs.global = this.selectedLogs.global.filter((x) => x !== type);
                }
                break;
            case "SALES_INVOICE":
                if (this.selectedLogs.salesThirdParty && this.selectedLogs.salesThirdParty.length) {
                    if (!this.selectedLogs.global.includes(type)) {
                        this.selectedLogs.global.push(type);
                    }
                } else {
                    this.selectedLogs.global = this.selectedLogs.global.filter((x) => x !== type);
                }
                break;
            case "BANK":
                if (this.selectedLogs.banks && this.selectedLogs.banks.length) {
                    if (!this.selectedLogs.global.includes(type)) {
                        this.selectedLogs.global.push(type);
                    }
                } else {
                    this.selectedLogs.global = this.selectedLogs.global.filter((x) => x !== type);
                }
                break;
        }
    }

    onExportFileFinished() {
        this.exportGeneralLedgerDialog = false;
        this.exportDialog = false;
        this.refresh();
    }

    get disabledPermanentFecBtn() {
        if (!this.accountingPeriod?.closed) {
            this.tooltipMessage = "La période comptable n'est pas cloturée";
            this.fecExportOptions.permanentFEC = false;
            return true;
        }
        if (this.accountingClosing) {
            if (
                this.formatDateYYYYMMDD(this.accountingClosing.endDate) !==
                this.formatDateYYYYMMDD(this.accountingPeriod.end)
            ) {
                this.tooltipMessage = "La situation n'est pas à la fin de la période comptable";
                this.fecExportOptions.permanentFEC = false;
                return true;
            }
        }
        return false;
    }

    get disabledDatePicker() {
        if (this.fecExportOptions.onlyNotExported) {
            return false;
        }
        if (this.accountingPeriod?.closed && this.fecExportOptions.permanentFEC) {
            return true;
        }
        if (this.accountingClosing?.id?.length) {
            return true;
        }
        // if (this.fecExportOptions.onlyNotExported) {
        //     return true
        // }
        return false;
    }

    onPermanentFecChange() {
        if (this.fecExportOptions.permanentFEC) {
            this.fecExportOptions.extentionFile = "TXT";
        }
        this.fecExportOptions.onlyNotExported = false;
        this.fecDates();
    }

    async publish({ id }) {
        await this.$apollo.mutate({
            mutation: SHARE_EXPORT,
            variables: {
                id: id,
            },
        });
        this.refresh();
    }

    @Apollo({
        query() {
            return EXTENSIONS_LIST;
        },
        variables() {
            return {
                type: "DIALOG",
                displayIn: "EXPORT",
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.extensions = data.getExtensions;
            }
        },
    })
    extensions = [];

    selectedExtension = null;

    getFecExportTableRules(item) {
        let prefix = 0;
        const name = item.slice(0, 3);
        switch (name) {
            case "401":
                prefix = this.fecExportOptions.supplierPrefix.length;
                break;
            case "411":
                prefix = this.fecExportOptions.customerPrefix.length;
                break;
            case "421":
                prefix = this.fecExportOptions.aa421Suffix.length;
                break;
            case "425":
                prefix = this.fecExportOptions.aa425Suffix.length;
                break;
            case "455":
                prefix = this.fecExportOptions.aa455Suffix.length;
                break;
            case "467":
                prefix = this.fecExportOptions.aa467Suffix.length;
                break;
        }

        let rules = [
            (v) => !!v || this.$t("settings.itemRequired"),
            (v) =>
                v.length <= this.fecExportOptions.auxiliaryCharacterCount - prefix ||
                this.$t("settings.tooLong"),
        ];

        return rules;
    }

    calculateFECWordings() {
        const exportOptions = new ExportFECServices(
            this.fecExportOptions,
            this.exportMappingFEC.options,
        );
        exportOptions.sameOptionsInDB();
        let tpItems = exportOptions.formatTP(this.exportMappingFEC.thirdPartyCompanies);
        this.auxiliaryItems = tpItems.auxiliaryItems;
        this.userItems = tpItems.userItems;
        this.accountableAccountItems = exportOptions.formatAA(
            this.exportMappingFEC.accountableAccounts,
        );
        this.bankAccountItems = exportOptions.formatBA(this.exportMappingFEC.bankAccounts);
        this.journalLibMaxChar = exportOptions.softwareExport.JournalLib;
        this.fecExportOptions.accountableAccountCharacterCount =
            exportOptions.accountableAccountCharacterCount;
    }

    setFormatLimits() {
        const softwareExport = softwareExportFormats[this.fecExportOptions.softwareExport];
        if (softwareExport.CompteNum !== 1e3) {
            this.fecExportOptions.accountableAccountCharacterCount = softwareExport.CompteNum;
        } else {
            this.fecExportOptions.accountableAccountCharacterCount = 9;
        }
        if (softwareExport.CompAuxNum !== 1e3) {
            this.fecExportOptions.auxiliaryCharacterCount = softwareExport.CompAuxNum;
        } else {
            this.fecExportOptions.auxiliaryCharacterCount = 10;
        }
    }
}

export default toNative(ExportAccounting);
</script>
